import { Doc, generateToDocFn } from '@dadohr/shared/domainTypes/document';
import { MicrosoftTeamsTeam } from '@dadohr/shared/domainTypes/experience';
import { MicrosoftIntegrationConfig } from '@dadohr/shared/domainTypes/integrations/microsoft';
import { FS } from '@dadohr/shared/versions';
import {
  store,
  useMappedLoadingValue
} from '../../../../../../services/firebase';
import { callFirebaseFunction } from '../../../../../../services/firebaseFunctions';
import {
  createDocumentListenerGetter,
  useDocumentListener
} from '../../../../../../services/firecache/documentListener';
import { now } from '../../../../../../services/time';

export type MicrosoftTeamsChannel = {
  id: string;
  name: string;
  kind: 'STANDARD' | 'PRIVATE' | 'SHARED';
};

export const toMicrosoftConfigDoc = generateToDocFn<MicrosoftIntegrationConfig>();

const COLLECTION = FS.microsoftIntegrationConfig;
const collection = () => store().collection(COLLECTION);

export const microsoftConfigStore = createDocumentListenerGetter(
  (orgId: string) => collection().doc(orgId),
  toMicrosoftConfigDoc
);

export const getMicrosoftTeamsTeamList = (orgId: string) => {
  return callFirebaseFunction<MicrosoftTeamsTeam[]>(
    'integrations_microsoft-getTeamsTeamList',
    { orgId }
  );
};

export const getMicrosoftTeamsChannelList = (orgId: string, teamId: string) => {
  return callFirebaseFunction<MicrosoftTeamsChannel[]>(
    'integrations_microsoft-getTeamsChannelList',
    { orgId, teamId }
  );
};

export const useMicrosoftConfig = (orgId: string, userId: string) => {
  return useMappedLoadingValue(
    useDocumentListener(microsoftConfigStore(orgId)),
    (d) => {
      if (!d) {
        const n = now();
        const newConfig: Doc<MicrosoftIntegrationConfig> = {
          id: orgId,
          collection: COLLECTION,
          data: {
            orgId,
            active: false,
            createdAt: n,
            createdBy: userId,
            editedAt: n,
            editedBy: userId,
            serializedTokenCache: '',
            tenantId: '',
            accountId: '',
            idToken: '',
            accessToken: '',
            expireDate: 0,

            scopes: []
          }
        };
        return newConfig;
      }
      return d;
    }
  );
};

export const removeMicrosoftConfig = (orgId: string) => {
  return collection().doc(orgId).delete();
};
